import { render, staticRenderFns } from "./sayer.vue?vue&type=template&id=502e235e&scoped=true&"
import script from "./sayer.vue?vue&type=script&lang=js&"
export * from "./sayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502e235e",
  null
  
)

export default component.exports